module.exports = __webpack_public_path__ + "img/clinic-hover.5cdabfa8.svg";